<template>
    <div>

        <!-- <sequential-entrance from-right> -->
        <template v-for="(topic, i) in allTopics">
            <div
                v-show="topic.id !== 4 && fullDataIndex[topic.id] && fullDataIndex[topic.id].courses && fullDataIndex[topic.id].courses.length"
                :key="`topic-${i}`"
                :class="`topic ${topic.id === exploreCardOpen ? 'currentOpen' : ''}`"
            >
                <f7-block-title style="margin: 40px 0 0 20px; line-height: 20px;">
                    {{ topic.name }}
                </f7-block-title>

                <f7-swiper
                    :params="{slidesOffsetBefore: 12, speed:500, slidesPerView: 'auto', spaceBetween: 6, noSwiping: true}"
                    :navigation="!isPgap && !exploreCardOpen"
                >

                    <template v-for="(course, j) in fullDataIndex[topic.id].courses">
                        <course-card
                            :course="course"
                            :topic="topic.id === 38 ? topicsIndex[course.topicId] : topic"
                            :link="`/courses/${course.id}`"
                            :key="`t-${i}-c-${j}`"
                            :locked="false"
                            :is-learn="true"
                            :disabled="topic.comingSoon"
                            :style="topic.comingSoon ? 'opacity: 0.5' : ''"
                        />
                    </template>
                </f7-swiper>
            </div>

        </template>
        <!-- </sequential-entrance> -->

    </div>
</template>

<script>
import utils from '../../js/utils';

import CourseCard from '../../components/courseCard.vue';

export default {
    store: ['api', 'user', 'topics',
        'topicsIndex', 'fullDataIndex', 'units', 'courses',
        'unitsIndex', 'coursesIndex', 'exploreCardOpen', 'myTraits'],
    components: {
        CourseCard: CourseCard
    },
    data () {
        return {
            customTopics: []
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        },
        allTopics: function () {
            let goodOnes = [];
            for (let i = 0; i < this.topics.length; i++) {
                const topic = this.topics[i];
                const tmpCourses = [];

                if (topic.type === 'learn') {
                    // new for you
                    if (topic.id === 38) {
                        let units = this.units.slice().sort((a, b) => {
                            var dateA = new Date(a.createdAt);
                            var dateB = new Date(b.createdAt);
                            return dateA - dateB;
                        }).reverse();
                        for (let i = 0; i < units.length; i++) {
                            var fortnightAway = new Date(Date.now() - 12096e5 * 2);
                            if ((new Date(units[i].createdAt).getTime() - fortnightAway.getTime()) > 0) {
                                for (let j = 0; j < units[i].courses.length; j++) {
                                    const c = units[i].courses[j];
                                    if (c.courseId &&
                                        tmpCourses.indexOf(c.courseId) === -1 &&
                                        this.coursesIndex[c.courseId] &&
                                        ['learn'].indexOf(this.coursesIndex[c.courseId].type) > -1 &&
                                        this.unitsIndex[units[i].id] &&
                                        utils.checkTraits(this.myTraits, this.coursesIndex[c.courseId]) &&
                                        utils.checkTraits(this.myTraits, this.unitsIndex[units[i].id]) &&
                                        tmpCourses.length < 5) {
                                        tmpCourses.push(c.courseId);
                                    }
                                }

                            }
                        }
                    }
                    // Admin
                    // Don't show CORAL TEST topic for a user if user is not an admin
                    if (topic.id === 5 && !this.user.isAdmin) continue;

                    goodOnes.push(topic);
                    goodOnes[goodOnes.length - 1].courses = this.fullDataIndex[topic.id] ? this.fullDataIndex[topic.id].courses : [];

                    if (topic.id === 38 && tmpCourses.length) {
                        goodOnes[goodOnes.length - 1].courses = [];
                        this.fullDataIndex[topic.id].courses = [];
                        for (let i = 0; i < tmpCourses.length; i++) {
                            // Disable visibility in "New For You" section for all Coral Test
                            const coralTestTopicId = 5;
                            if (this.coursesIndex[tmpCourses[i]].topicId === coralTestTopicId) continue;

                            goodOnes[goodOnes.length - 1].courses.push(this.coursesIndex[tmpCourses[i]])
                            this.fullDataIndex[topic.id].courses.push(this.coursesIndex[tmpCourses[i]])
                        }
                    }
                }
            }
            return this.customTopics.concat(goodOnes);
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        goToInPopup: function (url) {
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 250);
            // f7.statusbar.setTextColor('white');
        },
        goTo: function (url) {
            f7.views['main'].router.navigate(url);
        }
    }
};
</script>
<style lang="less" scoped>
</style>
